import { FlexView } from '@cuemath/comps';
import { USER_CONFIG } from 'constants/api';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import { Grid, Message } from 'semantic-ui-react';

import { get as getConfig } from 'actions/configs';
import {
  get as getStudentAccountInfo,
  invalidateItem as invalidateAccountDetails,
} from 'actions/student-account';

import { trackEvent } from 'modules/analytics';
import { getCookie } from 'utils';
import { InfoViewLabel } from '../utils/comps';
import StudentProfile from './studentProfile';

class StudentPII extends PureComponent {
  static defaultProps = {
    studentAccount: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      errorText: null,
      studentProfileInfo: null,
      detailsUpdated: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    const { detailsUpdated } = state;
    const { studentAccount, actions } = props;
    const { studentId } = props.match.params;

    if (detailsUpdated) {
      actions.invalidateAccountDetails(studentId);
      newState.detailsUpdated = false;
    }

    const studentAccountGet = store.get(studentAccount, studentId) || {};

    if (studentAccountGet && studentAccountGet.isLoaded && !studentAccountGet.isStale) {
      if (studentAccountGet && Object.keys(studentAccountGet.data).length) {
        newState.studentProfileInfo = studentAccountGet.data;
      } else {
        newState.errorText = 'Student with this id does not exist';
      }
    } else if (studentAccountGet && studentAccountGet.isStale) {
      actions.getStudentAccountInfo(studentId);
    }

    return newState;
  }

  componentDidMount() {
    const { actions, userConfig } = this.props;
    const { studentId } = this.props.match.params;

    if (!userConfig) {
      actions.getConfig(USER_CONFIG);
    }

    if (studentId) actions.getStudentAccountInfo(studentId);
    trackEvent('STUDENT_PERSONAL_INFORMATION_VIEWED', {
      student_id: studentId,
      user_id: getCookie('emp_id'),
    });
  }

  onUpdate = () => {
    this.setState({ detailsUpdated: true });
  };

  render() {
    const { errorText, studentProfileInfo } = this.state;

    let isReady = false;

    if (studentProfileInfo) {
      isReady = true;
    }

    return (
      <FlexView alignItems="center">
        <InfoViewLabel resource="Student" />
        <Grid>
          {errorText && (
            <Message negative>
              <p>{errorText}</p>
            </Message>
          )}

          {isReady && (
            <Grid.Row>
              <Grid.Column>
                <StudentProfile {...this.state} onUpdate={this.onUpdate} />
              </Grid.Column>
            </Grid.Row>
          )}
        </Grid>
      </FlexView>
    );
  }
}

export default connect(
  ({ studentAccount, configs }) => ({
    studentAccount,
    userConfig: store.get(configs, USER_CONFIG),
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        getConfig,
        getStudentAccountInfo,
        invalidateAccountDetails,
      },
      dispatch,
    ),
  }),
)(StudentPII);
